/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardVulnerabilityRegionCount {
    getFixupPrototypeFunction() { return SecurityDashboardVulnerabilityRegionCount.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardVulnerabilityRegionCount>): SecurityDashboardVulnerabilityRegionCount {
        let obj = Object.assign(new SecurityDashboardVulnerabilityRegionCount(), model);
        SecurityDashboardVulnerabilityRegionCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardVulnerabilityRegionCount>): SecurityDashboardVulnerabilityRegionCount {
        if (!model) return null;
        return SecurityDashboardVulnerabilityRegionCount.newInstance(<SecurityDashboardVulnerabilityRegionCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardVulnerabilityRegionCount) {
        if (!obj) return;

        models.SecurityDashboardVulnerabilityRegionCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardVulnerabilityRegionCount): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardVulnerabilityRegionCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count_by_regions) {
            for (let val of this.count_by_regions) {
                models.SecurityDashboardVulnerabilityRegionValue.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility for the Cloud Provider
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Vulnerability Count by region
     */
    count_by_regions: Array<models.SecurityDashboardVulnerabilityRegionValue>;

}
